import React from 'react';
import { Icon } from 'antd';

export const BodyScroll = show => {
  const body = document.getElementsByTagName('body')[0];
  if (show && body) {
    body.className = 'modal-open';
  } else body.className = '';
};

export const GetHeader = (list, id) => {
  const result = list.find(item => item.id === id);
  return result
    ? result
    : { cover: {}, title: 'Header Title', subtitle: 'Header Subtitle' };
};

export const constructFormData = payload => {
  let result = new FormData();
  Object.keys(payload).map(key => {
    result.append(key, payload[key]);
    return key;
  });
  return result;
};

export const isAdmin = user => {
  let admin = false;
  if (user && user.roles) {
    user.roles.map(role => {
      if (role.id === 1 || role.id === 2) {
        admin = true;
      }
      return role;
    });
  }
  return admin;
};

export const scrollTop = () => {
  BodyScroll(false);
  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
};

export const RenderFileIcon = file => {
  if (file.type.indexOf('pdf') >= 0) return <Icon type="file-pdf" />;
  if (file.type.indexOf('image') >= 0) return <Icon type="file-jpg" />;
  if (file.type.indexOf('spreadsheet') >= 0) return <Icon type="file-excel" />;
  if (file.type.indexOf('word') >= 0) return <Icon type="file-word" />;
  return <Icon type="file" />;
};



// WEBPACK FOOTER //
// ./src/components/Utils.js